export const isVideo = (mimeType: string = '') => mimeType?.startsWith('video/')
